import { Form } from '@kanda-libs/ks-component-ts';
import { Loader } from '@kanda-libs/ks-design-library';

import { Details } from 'pages/CreateJob/components';

import Container from './Summary-container';

import { Page } from '../..';
import { Summary } from '../../../../components';
import { SubscriptionModal } from './components';

const ViewComponent = () => (
  <Container>
    {({ nextButtonProps, isSubmitting, form, onSubmit }) => (
      <Form id="create-job-summary-mobile" form={form} onSubmit={onSubmit}>
        <Page nextButtonProps={nextButtonProps} simpleHeader saveButton>
          <div className="flex flex-col -mt-4">
            <Details.ChangesBanner />
            <Summary.Header />
            <Summary.CompanyDetails />
            <Summary.JobDetails />
            <Summary.PaymentMethods />
            <SubscriptionModal />
            <Summary.CompleteAccountBadge />
            <Summary.AccountCompletedBadge />
          </div>
          <Loader isLoading={isSubmitting} />
        </Page>
      </Form>
    )}
  </Container>
);

ViewComponent.displayName = 'CreateJob-Summary-Mobile-view';

export default ViewComponent;
